export enum ItemType {
  Default = 0,
  Signature = 1,
  WalkdownSignature = 2,
  RequestComments = 3,
  ActionItem = 4,
}
